'use strict';

function updateImages(elements, skipAlreadyLoadedImages) {
    if (!elements) {
        return;
    }
    const selector = skipAlreadyLoadedImages ? '.js-dm-image:not(.dm-responsive-image-initialized)' : '.js-dm-image';
    const $imageElements = $(selector, elements);
    if (!$imageElements || !$imageElements.length) {
        return;
    }

    for (let i = 0; i < $imageElements.length; i++) {
        const imageElement = $imageElements[i];
        if (!imageElement) {
            continue;
        }
        window.dispatchEvent(new CustomEvent('dm.image.init', {
            detail: {
                element: imageElement
            }
        }));
    }
}

function updateVideo(videoElements, config, onInitCallback) {
    if (!videoElements) {
        return;
    }

    for (let i = 0; i < videoElements.length; i++) {
        const videoElement = videoElements[i];
        if (!videoElement) {
            continue;
        }
        window.dispatchEvent(new CustomEvent('dm.video.init', {
            detail: {
                element: videoElement,
                config: config,
                onInitCallback: onInitCallback
            }
        }));
    }
}

module.exports = {
    updateImages: updateImages,
    updateVideo: updateVideo
};
